import { useState } from 'react'

//Components
import SelectAddress from 'pages/dashboard/e-reporting/forms/components/reuseables/select-address/SelectAddress'

//Hoc
import withFetch from './withFetch'

//Context
import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

function PilihAreaPemilikProperti({ data }) {
  //Context
  const { setCurrentStep, formHandler, handlePrevState } = useFormMethod();
  const { isAprroval, form } = useFormState()

  const [selectedData, setSelectedData] = useState({
    ...form.area_pemilik_properti.value,
    value: form.area_pemilik_properti.value.id,
    label: form.area_pemilik_properti.value.name
  })

  const onNext = () => {
    handlePrevState()
    formHandler('area_pemilik_properti', selectedData)
    setCurrentStep(STEPS.alamatPemilikProperti)
  }
  return (
    <SelectAddress
      order="a. "
      question={'Di area mana domisili pemilik?'}
      placeholder="Tulis area"
      required
      data={data}
      selectedData={selectedData}
      setSelectedData={setSelectedData}
      onNext={onNext}
      showButton={true}
      disabled={isAprroval}
    />
  )
}

export default withFetch(PilihAreaPemilikProperti)